import AppIcon from "../Icon";

import { CustomArrowProps } from "react-slick";

interface SlickNavButtonProps extends CustomArrowProps {
    navDirection: "prev" | "next" | "up" | "down";
    // onClick: () => void;
}

export default function SlickNavButton(props: SlickNavButtonProps) {
    const { className, navDirection, style, onClick} = props;

    const icons = {
        prev: {
            icon: "arrowLongRight",
            className: "right-0",
        },
        next: {
            icon: "arrowLongLeft",
            className: "left-0",
        },
        up: {
            icon: "arrowLongUp",
            className: "left-0",
        },
        down: {
            icon: "arrowLongDown",
            className: "right-0",
        },
    }

    return (
        <button
            type="button"
            className={`${icons[navDirection].className} size-11 absolute top-1/2 transform -translate-y-1/2 z-10 cursor-pointer bg-gray-600 flex justify-center 
                        items-center rounded-full`}
            // style={{...style}}
            onClick={onClick}
        >
            <AppIcon icon={icons[navDirection].icon} className="text-lg text-gray-200" />
        </button>
    );
}